export enum OperationId {
  newUser = 101,
  contractSign = 310,
  recoverUser = 104,
  changePassword = 105
}
